<template>
  <v-card flat>
    <v-data-table
      :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
      :headers="headers"
      :items="payload"
      :search="search"
      :loading="loading"
      mobile-breakpoint="0"
      :options.sync="tableOptions"
      :server-items-length="totalPayload"
    >
      <template v-slot:[`item._id`]="{ item }">
        <p class="my-0 py-0">
          {{
            payload
              .map(function(x) {
                return x._id;
              })
              .indexOf(item._id) + 1
          }}
        </p>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip class="green white--text" x-small>{{ item.status }}</v-chip>
      </template>
      <template v-slot:[`item.amount`]="{ item }">
        {{ formatAmount(item.amount) }}
      </template>
      <template v-slot:[`item.paymentDate`]="{ item }">
        <p>
          {{
            item.paymentDate
              ? dateFormat(new Date(parseInt(item.paymentDate)))
              : "-"
          }}
        </p>
      </template>
      <template v-slot:[`item.paymentMethod`]="{ item }">
        <v-chip v-if="item.paymentMethod" class="green white--text" x-small>{{
          item.paymentMethod
        }}</v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <v-icon color="primary" @click="editBooking(item)">mdi-pencil</v-icon>
          <v-icon color="red" @click="showDeleteDialog(item)"
            >mdi-delete</v-icon
          >
        </v-row>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import moment from "moment";
export default {
  props: [
    "payload",
    "headers",
    "search",
    "loading",
    "options",
    "totalPayload",
    "tab"
  ],
  data() {
    return {
      tableOptions: this.options
    };
  },
  watch: {
    tableOptions() {
      const input = {
        limit:
          this.tableOptions.itemsPerPage !== -1
            ? this.tableOptions.itemsPerPage
            : this.totalPropertyType,
        skip:
          this.tableOptions.page * this.tableOptions.itemsPerPage -
          this.tableOptions.itemsPerPage
      };
      this.$root.$emit("seletedTab", this.tab, input);
    }
  },
  methods: {
    formatAmount(amount) {
      if (amount) {
        return parseFloat(amount).toFixed(3);
      }
      return "";
    },
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY, h:mm:ss");
    }
  }
};
</script>

<style></style>
